import { db } from '@/main';
import moment from 'moment'

const state = {
    todo : []
}

// getters
const getters = {

}

// mutations
const mutations = {
    taskActive:(state,payload)=>{
        var updatestatus = "";
        state.todo.find(function (list) {
            if (list.id == payload) {
                if(list.visibility == true){
                    updatestatus = false
                }
                else if(list.visibility == false){
                    updatestatus = true
                }
            }
        })
        const updateRef = db.collection('Rank').doc(payload);
        updateRef.update({ visibility:updatestatus })
    },
    tododelete:(state,payload)=>{
        db.collection('Rank').doc(payload).delete()
    },
    retrieveTodos(state,todos){
        state.todo = todos
    }
};

// actions
const actions = {
    retrieveTodos:(context, days)=>{
        
        //----------------------------------------
        // 한주의 시작과 끝을 찾아 냅니다.  
        var dateFormat = require('dateformat');
        var curr = new Date();
        curr.setHours(0,0,0,0);
        var firstday = new Date(curr.setDate(curr.getDate() - curr.getDay())+days);

        console.log('firstday = '+firstday);
        
        db.collection('Rank')
        .doc("WEEK-"+dateFormat(firstday, "yyyy-mm-dd"))
        .collection('DAY-1').orderBy('score', 'desc').limit(10).get()
        .then((querySnapshot)=>{
            var tempTodos = []

            querySnapshot.forEach((doc)=>{
                tempTodos.push({ 
                    id:doc.id, 
                    //keyword:doc.data().keyword,
                    userUid:doc.data().userUid,
                    userName:doc.data().userName, 
                    userPhotoUrl:doc.data().userPhotoUrl, 
                    //version:doc.data().version,
                    country:doc.data().country,
                    score:doc.data().score,
                    //league:doc.data().league,
                    //leaguePoint:doc.data().leaguePoint,
                    level:doc.data().level,
                    //lastRank:doc.data().lastRank,
                    //period:doc.data().period,
                    visibility:doc.data().visibility,
                    created:moment(String(doc.data().created.toDate())).format('YYYY-MM-DD hh:mm')
                 });
            })
            var tempTodosSorted = tempTodos.sort((a,b)=>{
                return a.created.seconds - b.created.seconds
            })
            context.commit('retrieveTodos',tempTodosSorted)
        })
    },
    taskActive:(context, payload) => {
        context.commit('taskActive',payload)
    },
    tododelete:(context, payload) => {
        context.commit('tododelete',payload)
    },
    getThisWeek()
    {
      var dateFormat = require('dateformat');
      var curr = new Date();
      curr.setHours(0,0,0,0);
      var firstday = new Date(curr.setDate(curr.getDate() - curr.getDay()));
      return dateFormat(firstday, "yyyy-mm-dd");
    }
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}